app.service('accountComparisonView', function (account, modal, loading) {
	let $self, $comparisonList;
	let modalId = null, modalMode = null;
	const validationErrorMessage = 'Pole nie może być puste.';

	function setElements() {
		$self = $('#comparison-products');
		$comparisonList = $('#product-comparison-list', $self);
	}

	function setEvents() {
		$comparisonList.on('click', '.js-comparison-modal-open', function () {
			modalId = $(this).data('id');
			modalMode = $(this).data('modalMode');
			showComparisonModal();
		});
	}

	// utils - start
	function getComparisonModalBody() {
		return $comparisonList.find(`#comparison-modal-${modalMode}-${modalId}`).html();
	}

	function getModal() {
		return $('#comparison-modal');
	}

	function getModalInputValue() {
		return getModal().find('.js-modal-input').val().trim();
	}

	function getRenameModalInput() {
		return getModal().find('.comparison-rename-input');
	}

	function getNoteModalInput() {
		return getModal().find('.comparison-note-textarea');
	}

	function getValidationErrorElement() {
		return getModal().find('.js-comparison-modal-error');
	}

	function hideValidationError($input) {
		getValidationErrorElement().prop('hidden', true).text(validationErrorMessage);
		$input.attr('aria-invalid', 'false');
	}

	function showValidationError($input) {
		getValidationErrorElement().prop('hidden', false).text(validationErrorMessage);
		$input.attr('aria-invalid', 'true').focus();
	}

	function bindValidation($input) {
		$input.on('input', function () {
			if ($(this).val().trim().length) {
				hideValidationError($input);
			}
		});
	}
	// utils - end

	// modals - start
	function showComparisonModal() {

		switch (modalMode) {
			case 'rename':
				showRenameModal();
				break;
			case 'add-note':
			case 'change-note':
				showNoteModal();
				break;
			case 'delete':
				showDeleteComparisonModal();
				break;
			case 'delete-note':
				showDeleteNoteModal();
				break;
		}
	}

	function showRenameModal() {
		modal.generate({
			id: 'comparison-modal',
			modifier: `mode-${modalMode}`,
			content: getComparisonModalBody(),
			callbackOpen: function () {
				this.$modal.find('.js-modal-title').focus();
				const $input = getRenameModalInput();
				hideValidationError($input);
				bindValidation($input);
			},
			buttons: [
				{
					text: 'Anuluj',
					cssClass: 'cancel',
					click: () => modal.close()
				},
				{
					text: 'Zapisz',
					cssClass: 'confirm',
					click: () => {
						const newName = getModalInputValue();
						if (!newName.length) {
							showValidationError(getRenameModalInput());
							return;
						}

						renameComparison(newName);
						modal.close();
					}
				}
			]
		});
	}

	function showNoteModal() {
		modal.generate({
			id: 'comparison-modal',
			modifier: `mode-${modalMode}`,
			content: getComparisonModalBody(),
			callbackOpen: function () {
				this.$modal.find('.js-modal-title').focus();
				const $input = getNoteModalInput();
				hideValidationError($input);
				bindValidation($input);
			},
			buttons: [
				{
					text: 'Anuluj',
					cssClass: 'cancel',
					click: () => modal.close()
				},
				{
					text: 'Zapisz',
					cssClass: 'confirm',
					click: () => {
						const note = getModalInputValue();
						if (!note.length) {
							showValidationError(getNoteModalInput());
							return;
						}

						saveComparisonNote(note);
						modal.close();
					}
				}
			]
		});
	}

	function showDeleteComparisonModal() {
		modal.generate({
			id: 'comparison-modal',
			modifier: `mode-${modalMode}`,
			content: getComparisonModalBody(),
			callbackOpen: function () {
				this.$modal.find('.js-modal-title').focus();
			},
			buttons: [
				{
					text: 'Usuń',
					cssClass: 'remove',
					click: () => {
						modal.close();
						deleteFromComparisonClipboard();
					}
				},
				{
					text: 'Wróć do porównania',
					cssClass: 'confirm',
					click: () => modal.close()
				}
			]
		});
	}

	function showDeleteNoteModal() {
		modal.generate({
			id: 'comparison-modal',
			modifier: `mode-${modalMode}`,
			content: getComparisonModalBody(),
			callbackOpen: function () {
				this.$modal.find('.js-modal-title').focus();
			},
			buttons: [
				{
					text: 'Usuń',
					cssClass: 'remove',
					click: () => {
						modal.close();
						deleteComparisonNote();
					}
				},
				{
					text: 'Wróć do porównania',
					cssClass: 'confirm',
					click: () => modal.close()
				}
			]
		});
	}
	// modals - end

	// requests - start
	function deleteFromComparisonClipboard() {
		if (account.isFrontUserLogged()) {
			loading.start();
			$.ajax({
				url: '/konto-usun-porownanie.ltr',
				type: 'POST',
				data: {
					comparisonId: modalId
				},
				success: function () {
					loading.reload();
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd podczas usuwania porównania. Spróbuj ponownie później.');
				}
			});
		}
	}

	function renameComparison(comparisonName) {
		loading.start();

		$.ajax({
			url: '/konto-zmien-nazwe-porownania.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				comparisonId: modalId,
				comparisonName
			}),
			success: function () {
				loading.reload();
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd podczas zmiany nazwy. Spróbuj ponownie później.');
			}
		});
	}

	function saveComparisonNote(comparisonNote) {
		loading.start();

		$.ajax({
			url: '/konto-zmien-notatke-porownania.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				comparisonId: modalId,
				comparisonNote
			}),
			success: function () {
				loading.reload();
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd podczas zapisywania notatki. Spróbuj ponownie później.');
			}
		});
	}

	function deleteComparisonNote() {
		loading.start();

		$.ajax({
			url: `/konto-usun-notatke-porownania.ltr?id=${modalId}`,
			type: 'POST',
			success: function () {
				loading.reload();
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd podczas usuwania notatki. Spróbuj ponownie później.');
			}
		});
	}
	// requests - end

	function init() {
		setElements();

		if (!$comparisonList.length) {
			return;
		}

		setEvents();
	}

	return {
		init
	};
});
